module.exports = __webpack_public_path__ + "img/success-icon.0c2c76b1.svg";